import React from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Home } from "./sections/Home.tsx";
import { About } from "./sections/About.tsx";
import { Features, Collection, Caresheet, BrowseMorphs, GeneticsCalculator } from "./sections/Features.tsx";
import { GetStarted } from "./sections/Demo.tsx";


type SectionComponent = React.ComponentType;
type SectionConfig = {
  component: SectionComponent;
  subComponents?: Record<string, { component: SectionComponent }>;
};


const Header = () => {
  return (
    <Navbar variant={'dark'} expand="lg" className='fixed-top'>
      <Navbar.Brand href="#home">
        <div id="logo" className="text-center">
          <img src="img/logo.svg" alt="RepTool" />
        </div>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto ml-auto mr-5">
          <Nav.Link href="#home">Home</Nav.Link>
          <Nav.Link href="#about">About</Nav.Link>
          <NavDropdown title="Features" id="basic-nav-dropdown">
            <NavDropdown.Item href="#genetics-calculator">Genetic Calculator</NavDropdown.Item>
            <NavDropdown.Item href="#browse-morphs">Morph List</NavDropdown.Item>
            <NavDropdown.Item href="#caresheet">Caresheets</NavDropdown.Item>
            <NavDropdown.Item href="#collection">Collection</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="#get-started">Get started</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )

}


const Footer = () => (
  <div id='footer-container'>

    <div className="container">
      <footer className="py-3">

        <ul className="nav justify-content-center border-bottom pb-3 mb-3">
          <li className="nav-item"><a href="#home" className="nav-link px-2 text-muted">Home</a></li>
          <li className="nav-item"><a href="#genetics-calculator" className="nav-link px-2 text-muted">Features</a></li>
          <li className="nav-item"><a href="#collection" className="nav-link px-2 text-muted">Collection</a></li>
          <li className="nav-item"><a href="#caresheet" className="nav-link px-2 text-muted">Care Sheets</a></li>
          <li className="nav-item"><a href="#about" className="nav-link px-2 text-muted">About</a></li>
        </ul>
        <p className="text-center text-muted">© {new Date().getFullYear()} RepTool</p>
      </footer>
    </div>
  </div>
)

const sections: Record<string, SectionConfig> = {
  home: { component: Home },
  about: { component: About },
  features: {
    component: Features,
    subComponents: {
      geneticCalculator: { component: GeneticsCalculator },
      browseMorphs: { component: BrowseMorphs },
      caresheet: { component: Caresheet },
      collection: { component: Collection },
    }
  },
  getStarted: { component: GetStarted },

}


export const Landing = () => {
  React.useEffect(() => {
    const onScroll = () => {
      const header = document.querySelector("nav");
      if (!(header instanceof HTMLElement)) {
        return;
      }
      header.classList.toggle("scrolled", window.scrollY > header.offsetHeight);
    }

    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])
  return (
    <>
      <Header />
      {Object.entries(sections).map(([sectionKey, sectionConfig]) => {
        const Section = sectionConfig.component;
        if (sectionConfig.subComponents) {
          return (
            <React.Fragment key={sectionKey}>
              <Section />
              {Object.entries(sectionConfig.subComponents).map(([subSectionKey, subSectionConfig]) => {
                const SubSection = subSectionConfig.component;
                return <SubSection key={subSectionKey} />
              })}
            </React.Fragment>
          )
        } else {
          return <Section key={sectionKey} />
        }
      })}
      <Footer />
    </>
  )
}